export default function PendingWhatsappConfig() {
    return (
        <div className="rounded border border-red-300 bg-red-50 text-red-900 p-4">
            <h2 className="text-lg font-semibold">Configuração pendente</h2>
            <p className="mt-1">
                Sua barbearia ainda não possui um número do WhatsApp
                configurado. Entre em contato com o suporte para configurar um
                número para você.
            </p>
        </div>
    );
}
